<template>
  <el-dialog
    :visible.sync="show"
    :close-on-click-modal="false"
    :top="t"
    :width="w"
    class="yi-dialog-root login_his_dia"
  >
    <div class="slot-dialog-header" slot="title">
      <span class="title">用户{{info.user}}的登录记录</span>
    </div>
    <div class="dialog-content">
      <vue-scroll :ops="disScrollOpt" v-if='info.list.length'>
        <div class="info_content">
          <div class="his-wrap">
            <div class="his_item header">
              <div class="time item_col">时间</div>
              <div class="ip item_col">IP</div>
              <div class="address item_col">地域</div>
              <div class="msg item_col">消息</div>
            </div>
            <div class="his_item" v-for="item in info.list" :key="item.id">
              <span class="time item_col">{{item.time | time}}</span>
              <span class="item_col ip">{{item.ip}}</span>
              <span class="address item_col">{{ item.city_name }}</span>
              <span class="item_col msg">{{item.msg}}</span>
            </div>
          </div>
        </div>
      </vue-scroll>
      <div class="empty_wrap_grey" v-show="!info.list.length">
        <yioks-empty-grey h='100%'></yioks-empty-grey>
      </div>
    </div>
    <!-- <div class="footer-btn" slot="footer">
      
    </div> -->
  </el-dialog>
</template>

<script>
import ops from "@/assets/js/vuescrollOption";

export default {
  name: "login-history-dialog",
  components: {
    "yioks-empty-grey": () => import("@/components/Tips/Empty-grey"),
  },
  data() {
    return {
      disScrollOpt: ops(true)
    };
  },
  props: {
    ifShow: {
      type: Boolean,
      required: true
    },
    t: {
      type: String,
      default: "20vh"
    },
    w: {
      type: String,
      default: "630px"
    },
    info: {
      type: Object,
      required: true,
    }
  },
  computed: {
    show: {
      get() {
        return this.ifShow;
      },
      set(bool) {
        this.$emit("hideDia", bool, false);
      }
    }
  },
  methods: {
    
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable';
@import '~@/assets/css/linDialog'

.login_his_dia {
  .dialog-content {
    height: 390px;
    .empty_wrap_grey {
      display block 
      text-align center 
      font-size 20px
      padding-top 80px
    }
    .info_content {
      display block 
      padding 0 15px 0 0
      .his-wrap {
        padding 0 10px
        .his_item {
          display flex 
          border-bottom 1px solid #ccc 
          &.header {
            font-size 16px 
            font-weight bolder
          }
          .item_col {
            display block 
            padding 8px 0 
            text-align center
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            &.time {
              width 28%
            }
            &.ip {
              width 20%
            }
            &.address {
              width 30%
            }
            &.msg {
              flex 1
            }
          }
        }

      }
    }
    
  }
  .footer-btn{
    text-align : center;
  }
}
</style>
